import "./tnt_react_app.scss";

let TNTReactAppComponent = {
  restrict: "E",
  bindings: {},
};

export default TNTReactAppComponent;



// WEBPACK FOOTER //
// ./client/app/components/tnt_react_app/tnt_react_app.component.js